<template>
  <div class="h-100">
    <rfp-header @sendEmail="onEmailRfp" />
    <b-card class="h-100">
      <b-card>
        <template v-slot:header>
          <h6 class="mb-0">Selected Parts</h6>
        </template>
        <selected-parts :isRfpNotPending="header.statusId != PENDING_STATUS_VALUE" @remove-part="onRemovePart" />
      </b-card>
      <b-card>
        <template v-slot:header>
          <h6 class="mb-0">
            Sourcing
            <i class="fa fa-question-circle ml-1" id="tooltip-sourcing"></i>
            <b-tooltip target="tooltip-sourcing" placement="right">
              The vendors listed below have been chosen to recieve a RFQ. Use the switch buttons to display/hide the type of souring or vendor. 
              Select the checkbox next to each part to send the RFQ for that part to the vendor.  
              To add additional vendors, click the Manually Source Vendor button.
            </b-tooltip>
          </h6>
          <div style="position:absolute; top:6px; right:10px;" >
            <b-button @click="onEmailRfp" class="mr-2" size="sm" variant="primary">Send Email</b-button>
            <b-button size="sm" :disabled="isRemoving" variant="danger" class="mr-2"
              @click="onRemoveSelectedVendor">
              <i v-if="isRemoving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>
              Remove Vendor
            </b-button>
            <b-button size="sm" :disabled="isReprocess" variant="success" @click="onReprocessSourcing" class="mr-2">
              <i v-if="isReprocess" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>
              Reprocess Sourcing
            </b-button>
            <b-button size="sm" variant="warning" @click="$bvModal.show('manual-sourcing-vendor')">
              Manually Source Vendor
            </b-button>
          </div>
        </template>
        <selected-vendors ref="selectedVendors" @selectedVendors="onSelectedVendors" @is-restored="isRestoring = !($event)" />
      </b-card>  
    </b-card>
    <b-modal size="xl" title="Manual Source" id="manual-sourcing-vendor" hide-footer>
      <vendors />
    </b-modal>
    <send-emails :sendEmailData="sendEmailData" :multipleRecipients="checkedVendors" @refresh="afterEmailSent" isMultipleSend :defaultReports="reportOption.map(x => x.report)" hideAttachments></send-emails>
  </div>
</template>

<script>
import { mapGetters, mapActions,mapState } from 'vuex';
import { RFP_STATUS, REPORTS_CONSTANTS } from '@/shared/constants';

import RfpHeader from './components/RfpHeader';
import SelectedParts from './components/SelectedParts';
import Vendors from './components/Vendors';
import SelectedVendors from './components/SelectedVendors';
import SendEmails from '@/shared/components/SendEmails/index';
const PENDING_STATUS_VALUE = 336;

export default {
  components: {
    RfpHeader,
    SelectedParts,
    Vendors,
    SelectedVendors,
    SendEmails
  },
  data() {
    return {
      PENDING_STATUS_VALUE,
      rfpStatus: RFP_STATUS,
      checkedVendors: [],
      sendEmailData:{},
      suggestedDeleted: false,
      isReprocess: false,
      isRemoving: false
    }
  },
  metaInfo() {
    return {
      title: `RFP #${this.rfpId || ''}`,
    };
  },
  computed: {
    ...mapGetters('rfpDetails', ['headerById']),
    ...mapGetters('rfpSelectedVendors', ['selectedVendors']),
    ...mapState('account', ['user']),
    rfpId() {
      return this.$route.params.id;
    },
    header() {
      return this.headerById(this.rfpId);
    },
    reportOption() {
      return REPORTS_CONSTANTS.filter(x => x.module == 'RFP');
    },
    isAutoSourcedDeleted() {
      return this.selectedVendors.filter(x => (x.isOfferSourced == 1 || x.isMfrSourced == 1) && x.active == 0).length > 0;
    }
  },
  methods: {
    ...mapActions('rfpDetails', [
      'getHeader',
      'getSalesPersonList'
    ]),
    ...mapActions('rfpSelectedVendors', ['reProcessSourcing']),
    onCancel() {
      this.$router.push({
        name: 'rfp.list',
      });
    },

    async onReprocessSourcing() {
      this.isReprocess = true;
      await this.reProcessSourcing(this.rfpId);
      this.isReprocess = false;
    },

    onSelectedVendors(evt) {
      // let selectedVendors = [];

      // for (let i = 0; i < evt.length; i++) {
      //   if (selectedVendors.findIndex(x => x.id == evt[i].vendorRFPId) == -1) {
      //     selectedVendors.push({ id: evt[i].vendorRFPId, email: evt[i].email, dateSent: evt[i].dateSent })
      //   }          
      // }

      // this.checkedVendors = selectedVendors;
    },

    onRemoveSelectedVendor() {
      this.checkedVendors = this.$refs['selectedVendors'].selectedItemData;

      if (this.checkedVendors.filter(x => x.dateSent != null).length > 0) {
        this.openAlertBox({message: 'Can`t delete vendor with email sent',okVariant: 'success'});
        return;
      } else {
        this.$refs['selectedVendors'].onDelete();
      }        
    },

    async onEmailRfp(){
      this.checkedVendors = this.$refs['selectedVendors'].selectedForEmail;

      if (this.checkedVendors.length > 0) {
        this.sendEmailData = {
          bcc:this.checkedVendors.map(x => x.email).join('; '),
          source:'RFP',
          template: 'RFP',
          to:this.user.username,
          ReferenceId:this.rfpId,
          // reportSelectionOptions: this.reportOption
        }
        this.$root.$emit('bv::show::modal', 'send-email-modal');
      } else {
        this.openAlertBox({message: 'Please select a vendor to send'});
      }
    },
    afterEmailSent() {
      this.$refs['selectedVendors'].getData();
      this.getHeader(this.rfpId);
    },
    onRemovePart() {
      this.$refs['selectedVendors'].getData();
    }
  },
  async mounted() {
    this.setContainerLoader(true);
    await this.getHeader(this.rfpId).then(async () => {
      this.setContainerLoader(false);
    await this.getSalesPersonList();
    }).catch(() => {
      this.setContainerLoader(false);
      //return back to listing page because error in fetch record
      this.$router.push({name: 'rfp.list'});
    });
  },
};
</script>

<style lang="scss">
.rfp {
  .buttons-panel {
    .btn {
      margin-left: 10px;
      margin-bottom: 10px;
    }
  }
}
</style>
